import styled from "styled-components";
import { device } from "../../../constants";

const Bar = styled.div`
  width: 32px;
  border: 2px solid var(--product-color);
  border-radius: 2px;

  @media ${device.laptop} {
    width: 48px;
  }
`;

export function HighlightBar() {
	return (
		<Bar />
	);
}
